import React from 'react'
import Pt from 'prop-types'
import { Label } from 'react-bootstrap'

export default function StateLabel({
  className,
  Component = Label,
  invert = false,
  state,
}) {
  let words = `${state.charAt(0).toUpperCase()}${state.slice(1)}`
  let style

  switch (state) {
    case 'active':
    case 'cancelled':
    case 'rejected':
      style = 'info'
      break

    case 'pending-install':
      style = invert ? 'success' : 'danger'
      words = 'Pending Install'
      break

    case 'installed':
    case 'ordered':
    case 'paid':
    case 'qualifying':
    case 'submitted':
      style = invert ? 'success' : 'danger'
      break

    case 'fault':
      style = 'danger'
      break

    case 'needs-info':
      style = 'warning'
      words = 'Needs Info'
      break

    case 'auto-process':
      style = 'success'
      words = 'Processing'
      break

    case 'new':
    default:
      style = 'warning'
      words = 'Incomplete'
  }

  return (
    <Component bsStyle={style} className={className}>
      {words}
    </Component>
  )
}

StateLabel.propTypes = {
  className: Pt.string,
  // eslint-disable-next-line react/forbid-prop-types
  Component: Pt.any,
  invert: Pt.bool,
  state: Pt.string.isRequired,
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/components/Signup/StateLabel.jsx